export const apiBase: string = '/api';
